module.exports = __webpack_public_path__ + "static/img/image_solutions_customization_01.fc524c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_customization_01.png
// module id = sYr6
// module chunks = 10